import { ResourceSubPipeline } from "../../utils";
import { getUserSnippetPipeline } from "../users";

function getTransactionsOrderSubPipeline(): ResourceSubPipeline {
  return {
    mainStages: [
      {
        $lookup: {
          from: "orders",
          localField: "orderId",
          foreignField: "_id",
          as: "order",
        },
      },
      {
        $unwind: { path: "$order", preserveNullAndEmptyArrays: true },
      },
    ],
    projectStage: {
      orderNumber: {
        $cond: {
          if: { $eq: ["$order.paymentDetails.orderFulfilled", true] },
          then: "$order.orderNumber",
          else: null,
        },
      },
    },
  };
}

function getTransactionUserSubPipeline(): ResourceSubPipeline {
  return {
    mainStages: [
      {
        $lookup: {
          from: "users",
          localField: "userId",
          foreignField: "_id",
          as: "userDoc",
        },
      },
      { $unwind: { path: "$userDoc", preserveNullAndEmptyArrays: true } },
    ],
    projectStage: {
      "userDoc.firstName": 1,
      "userDoc.lastName": 1,
      "userDoc.username": 1,
      "userDoc.email": 1,
    },
  };
}

export function getTransactionPipeline() {
  const payerUserSnippet = getUserSnippetPipeline("payerId", "payerDoc");
  const recipientUserSnippet = getUserSnippetPipeline("recipientId", "recipientDoc");

  const transactionsOrderPipeline = getTransactionsOrderSubPipeline();
  const userDoc = getTransactionUserSubPipeline();

  return {
    mainStages: [
      ...transactionsOrderPipeline.mainStages,
      ...userDoc.mainStages,
      ...recipientUserSnippet.mainStages,
      ...payerUserSnippet.mainStages,
    ],
    projectStage: {
      _id: 1,
      amount: 1,
      currency: 1,
      orderId: 1,
      source: 1,
      status: 1,
      type: 1,
      createdAt: 1,
      subject: 1,
      updatedAt: 1,
      refId: 1,
      ...transactionsOrderPipeline.projectStage,
      ...userDoc.projectStage,
      ...recipientUserSnippet.projectStage,
      ...payerUserSnippet.projectStage,
    },
  };
}
